import { AdHocReminderModel } from "./ad-hoc-reminder-model";

export class AdHocDebtReminderModel extends AdHocReminderModel {
  emails: string[];
  attachPayslip: boolean;
  companyName: string;

  constructor(data: Partial<AdHocDebtReminderModel>) {
    super(data);

    this.emails = data.emails ?? [];
    this.attachPayslip = data.attachPayslip ?? false;
    this.companyName = data.companyName ?? '';
  }
}
